/* eslint-disable import/no-anonymous-default-export */
export default {
  fontSize: 14,
  fontFamily:
    '"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif',
  htmlFontSize: 16,
  body1: {
    fontSize: 14,
    fontFamily:
      '"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif',
    fontWeight: 400,
    lineHeight: 1.6,
    letterSpacing: '-0.011em',
  },
  body2: {
    fontSize: 14,
    fontFamily:
      '"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif',
    fontWeight: 400,
    lineHeight: 1.57,
    letterSpacing: '-0.009em',
  },
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontFamily:
      '"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif',
    fontWeight: 800,
    fontSize: '3rem',
    lineHeight: 1.1,
    letterSpacing: '-0.05em',
    '@media (min-width:600px)': { fontSize: '3.75rem' },
    '@media (min-width:960px)': { fontSize: '4.5rem' },
    '@media (min-width:1280px)': { fontSize: '5rem' },
  },
  h2: {
    fontFamily:
      '"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif',
    fontWeight: 700,
    fontSize: '2rem',
    lineHeight: 1.15,
    letterSpacing: '-0.04em',
    '@media (min-width:600px)': { fontSize: '2.5rem' },
    '@media (min-width:960px)': { fontSize: '3rem' },
    '@media (min-width:1280px)': { fontSize: '3.5rem' },
  },
  h3: {
    fontFamily:
      '"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif',
    fontWeight: 700,
    fontSize: '1.5rem',
    lineHeight: 1.2,
    letterSpacing: '-0.03em',
    '@media (min-width:600px)': { fontSize: '1.75rem' },
    '@media (min-width:960px)': { fontSize: '2rem' },
    '@media (min-width:1280px)': { fontSize: '2.25rem' },
  },
  h4: {
    fontFamily:
      '"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif',
    fontWeight: 700,
    fontSize: '1.25rem',
    lineHeight: 1.25,
    letterSpacing: '-0.025em',
    '@media (min-width:600px)': { fontSize: '1.375rem' },
    '@media (min-width:960px)': { fontSize: '1.5rem' },
    '@media (min-width:1280px)': { fontSize: '1.75rem' },
  },
  h5: {
    fontFamily:
      '"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif',
    fontWeight: 600,
    fontSize: '1.125rem',
    lineHeight: 1.3,
    letterSpacing: '-0.02em',
  },
  h6: {
    fontFamily:
      '"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif',
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: 1.4,
    letterSpacing: '-0.015em',
  },
  subtitle1: {
    fontFamily:
      '"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif',
    fontWeight: 500,
    fontSize: '1rem',
    lineHeight: 1.6,
    letterSpacing: '-0.011em',
  },
  subtitle2: {
    fontFamily:
      '"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif',
    fontWeight: 500,
    fontSize: '0.875rem',
    lineHeight: 1.57,
    letterSpacing: '-0.009em',
  },
  button: {
    fontFamily:
      '"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: 1.75,
    textTransform: 'none',
    letterSpacing: '-0.01em',
  },
  caption: {
    fontFamily:
      '"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: 1.66,
    letterSpacing: '0.03em',
  },
  overline: {
    fontFamily:
      '"Inter",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif',
    fontWeight: 600,
    fontSize: '0.6875rem',
    lineHeight: 2.66,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
  },
}
